<template>
    <div class="_margin-bottom-30">
        <h4 class="question _margin-bottom-30">Your Petrol/Diesel Vehicle</h4>

        <div v-show="!quote.iceVehicle.make">
            <div class="row _margin-bottom-30">
                <div class="col-xs-12">
                    <label for="registrationIce">Enter Your Registration</label>
                    <validation-messages label="Vehicle registration" :$v="$v.iceVehicle.registrationNumber">
                        <div class="vrn">
                            <div class="vrn-input">
                                <svg width="49" height="82" viewBox="0 0 49 82" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24.4486 0L23.3842 3.27586L25.0222 3.80806L24.4486 0Z" fill="#FFCC00" />
                                    <path d="M24.4486 0L25.513 3.27586L23.8751 3.80806L24.4486 0Z" fill="#FFCC00" />
                                    <path d="M27.7245 2.38005H24.28V4.10227L27.7245 2.38005Z" fill="#FFCC00" />
                                    <path d="M27.7245 2.38005L24.9379 4.40464L23.9256 3.01134L27.7245 2.38005Z"
                                        fill="#FFCC00" />
                                    <path d="M26.4732 6.23106L25.4088 2.9552L23.7709 3.48739L26.4732 6.23106Z"
                                        fill="#FFCC00" />
                                    <path d="M26.4732 6.23106L23.6866 4.20646L24.6989 2.81316L26.4732 6.23106Z"
                                        fill="#FFCC00" />
                                    <path d="M21.1728 2.38005H24.6172V4.10227L21.1728 2.38005Z" fill="#FFCC00" />
                                    <path d="M21.1728 2.38005L23.9594 4.40464L24.9717 3.01134L21.1728 2.38005Z"
                                        fill="#FFCC00" />
                                    <path d="M22.424 6.23106L23.4884 2.9552L25.1264 3.48739L22.424 6.23106Z"
                                        fill="#FFCC00" />
                                    <path d="M22.424 6.23106L25.2106 4.20646L24.1983 2.81316L22.424 6.23106Z"
                                        fill="#FFCC00" />
                                    <path d="M24.4486 41.3333L23.3842 44.6092L25.0222 45.1414L24.4486 41.3333Z"
                                        fill="#FFCC00" />
                                    <path d="M24.4486 41.3333L25.513 44.6092L23.8751 45.1414L24.4486 41.3333Z"
                                        fill="#FFCC00" />
                                    <path d="M27.7245 43.7134H24.28V45.4356L27.7245 43.7134Z" fill="#FFCC00" />
                                    <path d="M27.7245 43.7134L24.9379 45.738L23.9256 44.3447L27.7245 43.7134Z"
                                        fill="#FFCC00" />
                                    <path d="M26.4732 47.5644L25.4088 44.2885L23.7709 44.8207L26.4732 47.5644Z"
                                        fill="#FFCC00" />
                                    <path d="M26.4732 47.5644L23.6866 45.5398L24.6989 44.1465L26.4732 47.5644Z"
                                        fill="#FFCC00" />
                                    <path d="M21.1728 43.7134H24.6172V45.4356L21.1728 43.7134Z" fill="#FFCC00" />
                                    <path d="M21.1728 43.7134L23.9594 45.738L24.9717 44.3447L21.1728 43.7134Z"
                                        fill="#FFCC00" />
                                    <path d="M22.424 47.5644L23.4884 44.2885L25.1264 44.8207L22.424 47.5644Z"
                                        fill="#FFCC00" />
                                    <path d="M22.424 47.5644L25.2106 45.5398L24.1983 44.1465L22.424 47.5644Z"
                                        fill="#FFCC00" />
                                    <path d="M3.78196 20.6667L2.71756 23.9425L4.35549 24.4747L3.78196 20.6667Z"
                                        fill="#FFCC00" />
                                    <path d="M3.78196 20.6667L4.84635 23.9425L3.20842 24.4747L3.78196 20.6667Z"
                                        fill="#FFCC00" />
                                    <path d="M7.05782 23.0467H3.61338V24.7689L7.05782 23.0467Z" fill="#FFCC00" />
                                    <path d="M7.05782 23.0467L4.27121 25.0713L3.25891 23.678L7.05782 23.0467Z"
                                        fill="#FFCC00" />
                                    <path d="M5.80655 26.8977L4.74216 23.6219L3.10423 24.1541L5.80655 26.8977Z"
                                        fill="#FFCC00" />
                                    <path d="M5.80655 26.8977L3.01993 24.8731L4.03223 23.4798L5.80655 26.8977Z"
                                        fill="#FFCC00" />
                                    <path d="M0.506104 23.0467H3.95055V24.7689L0.506104 23.0467Z" fill="#FFCC00" />
                                    <path d="M0.506104 23.0467L3.29272 25.0713L4.30501 23.678L0.506104 23.0467Z"
                                        fill="#FFCC00" />
                                    <path d="M1.75736 26.8977L2.82176 23.6219L4.45969 24.1541L1.75736 26.8977Z"
                                        fill="#FFCC00" />
                                    <path d="M1.75736 26.8977L4.54398 24.8731L3.53168 23.4798L1.75736 26.8977Z"
                                        fill="#FFCC00" />
                                    <path d="M12.0907 8.99987L14.8773 6.97528L13.865 5.58197L12.0907 8.99987Z"
                                        fill="#FFCC00" />
                                    <path d="M12.0907 8.99987L13.1551 5.72401L14.793 6.2562L12.0907 8.99987Z"
                                        fill="#FFCC00" />
                                    <path d="M10.8394 5.14886L13.626 7.17345L14.6383 5.78015L10.8394 5.14886Z"
                                        fill="#FFCC00" />
                                    <path d="M10.8394 5.14886H14.2839V6.87108L10.8394 5.14886Z" fill="#FFCC00" />
                                    <path d="M14.1153 2.76881L13.0509 6.04467L14.6888 6.57687L14.1153 2.76881Z"
                                        fill="#FFCC00" />
                                    <path d="M14.1153 2.76881L15.1797 6.04467L13.5417 6.57687L14.1153 2.76881Z"
                                        fill="#FFCC00" />
                                    <path d="M16.1399 8.99987L13.3533 6.97528L14.3656 5.58197L16.1399 8.99987Z"
                                        fill="#FFCC00" />
                                    <path d="M16.1399 8.99987L15.0755 5.72401L13.4376 6.2562L16.1399 8.99987Z"
                                        fill="#FFCC00" />
                                    <path d="M17.3912 5.14886L14.6045 7.17346L13.5922 5.78015L17.3912 5.14886Z"
                                        fill="#FFCC00" />
                                    <path d="M17.3912 5.14886H13.9467V6.87108L17.3912 5.14886Z" fill="#FFCC00" />
                                    <path d="M8.57536 16.5644L7.51097 13.2885L5.87304 13.8207L8.57536 16.5644Z"
                                        fill="#FFCC00" />
                                    <path d="M8.57536 16.5644L5.78875 14.5398L6.80104 13.1465L8.57536 16.5644Z"
                                        fill="#FFCC00" />
                                    <path d="M4.52618 16.5644L7.31279 14.5398L6.30049 13.1465L4.52618 16.5644Z"
                                        fill="#FFCC00" />
                                    <path d="M4.52618 16.5644L5.59057 13.2885L7.2285 13.8207L4.52618 16.5644Z"
                                        fill="#FFCC00" />
                                    <path d="M3.2749 12.7134L6.06152 14.738L7.07381 13.3447L3.2749 12.7134Z"
                                        fill="#FFCC00" />
                                    <path d="M3.2749 12.7134H6.71935V14.4356L3.2749 12.7134Z" fill="#FFCC00" />
                                    <path d="M9.82663 12.7134L7.04002 14.738L6.02772 13.3447L9.82663 12.7134Z"
                                        fill="#FFCC00" />
                                    <path d="M9.82663 12.7134H6.38219V14.4356L9.82663 12.7134Z" fill="#FFCC00" />
                                    <path d="M6.55077 10.3333L7.61516 13.6092L5.97723 14.1414L6.55077 10.3333Z"
                                        fill="#FFCC00" />
                                    <path d="M6.55077 10.3333L5.48638 13.6092L7.12431 14.1414L6.55077 10.3333Z"
                                        fill="#FFCC00" />
                                    <path d="M9.82664 33.3801H6.38219V35.1023L9.82664 33.3801Z" fill="#FFCC00" />
                                    <path d="M9.82664 33.3801L7.04002 35.4046L6.02772 34.0113L9.82664 33.3801Z"
                                        fill="#FFCC00" />
                                    <path d="M8.57536 37.2311L7.51097 33.9552L5.87304 34.4874L8.57536 37.2311Z"
                                        fill="#FFCC00" />
                                    <path d="M8.57536 37.2311L5.78875 35.2065L6.80104 33.8132L8.57536 37.2311Z"
                                        fill="#FFCC00" />
                                    <path d="M4.52618 37.2311L7.31279 35.2065L6.30049 33.8132L4.52618 37.2311Z"
                                        fill="#FFCC00" />
                                    <path d="M4.52618 37.2311L5.59057 33.9552L7.2285 34.4874L4.52618 37.2311Z"
                                        fill="#FFCC00" />
                                    <path d="M6.55077 31L7.61516 34.2759L5.97723 34.8081L6.55077 31Z" fill="#FFCC00" />
                                    <path d="M6.55077 31L5.48638 34.2759L7.12431 34.8081L6.55077 31Z" fill="#FFCC00" />
                                    <path d="M3.2749 33.3801H6.71935V35.1023L3.2749 33.3801Z" fill="#FFCC00" />
                                    <path d="M3.2749 33.3801L6.06152 35.4046L7.07381 34.0113L3.2749 33.3801Z"
                                        fill="#FFCC00" />
                                    <path d="M17.3912 40.9446H13.9467V42.6668L17.3912 40.9446Z" fill="#FFCC00" />
                                    <path d="M17.3912 40.9446L14.6045 42.9692L13.5922 41.5759L17.3912 40.9446Z"
                                        fill="#FFCC00" />
                                    <path d="M16.1399 44.7956L15.0755 41.5197L13.4376 42.0519L16.1399 44.7956Z"
                                        fill="#FFCC00" />
                                    <path d="M16.1399 44.7956L13.3533 42.771L14.3656 41.3777L16.1399 44.7956Z"
                                        fill="#FFCC00" />
                                    <path d="M12.0907 44.7956L14.8773 42.771L13.865 41.3777L12.0907 44.7956Z"
                                        fill="#FFCC00" />
                                    <path d="M12.0907 44.7956L13.1551 41.5197L14.793 42.0519L12.0907 44.7956Z"
                                        fill="#FFCC00" />
                                    <path d="M14.1153 38.5645L15.1797 41.8404L13.5417 42.3726L14.1153 38.5645Z"
                                        fill="#FFCC00" />
                                    <path d="M14.1153 38.5645L13.0509 41.8404L14.6888 42.3726L14.1153 38.5645Z"
                                        fill="#FFCC00" />
                                    <path d="M10.8394 40.9446H14.2839V42.6668L10.8394 40.9446Z" fill="#FFCC00" />
                                    <path d="M10.8394 40.9446L13.626 42.9692L14.6383 41.5759L10.8394 40.9446Z"
                                        fill="#FFCC00" />
                                    <path d="M45.1153 20.6667L46.1797 23.9425L44.5417 24.4747L45.1153 20.6667Z"
                                        fill="#FFCC00" />
                                    <path d="M45.1153 20.6667L44.0509 23.9425L45.6888 24.4747L45.1153 20.6667Z"
                                        fill="#FFCC00" />
                                    <path d="M41.8394 23.0467H45.2839V24.7689L41.8394 23.0467Z" fill="#FFCC00" />
                                    <path d="M41.8394 23.0467L44.626 25.0713L45.6383 23.678L41.8394 23.0467Z"
                                        fill="#FFCC00" />
                                    <path d="M43.0907 26.8977L44.1551 23.6219L45.793 24.1541L43.0907 26.8977Z"
                                        fill="#FFCC00" />
                                    <path d="M43.0907 26.8977L45.8773 24.8731L44.865 23.4798L43.0907 26.8977Z"
                                        fill="#FFCC00" />
                                    <path d="M48.3912 23.0467H44.9467V24.7689L48.3912 23.0467Z" fill="#FFCC00" />
                                    <path d="M48.3912 23.0467L45.6045 25.0713L44.5922 23.678L48.3912 23.0467Z"
                                        fill="#FFCC00" />
                                    <path d="M47.1399 26.8977L46.0755 23.6219L44.4376 24.1541L47.1399 26.8977Z"
                                        fill="#FFCC00" />
                                    <path d="M47.1399 26.8977L44.3533 24.8731L45.3656 23.4798L47.1399 26.8977Z"
                                        fill="#FFCC00" />
                                    <path d="M36.8065 8.99987L34.0199 6.97527L35.0322 5.58197L36.8065 8.99987Z"
                                        fill="#FFCC00" />
                                    <path d="M36.8065 8.99987L35.7422 5.72401L34.1042 6.2562L36.8065 8.99987Z"
                                        fill="#FFCC00" />
                                    <path d="M38.0578 5.14886L35.2712 7.17345L34.2589 5.78014L38.0578 5.14886Z"
                                        fill="#FFCC00" />
                                    <path d="M38.0578 5.14886H34.6134V6.87108L38.0578 5.14886Z" fill="#FFCC00" />
                                    <path d="M34.782 2.76881L35.8463 6.04467L34.2084 6.57686L34.782 2.76881Z"
                                        fill="#FFCC00" />
                                    <path d="M34.782 2.76881L33.7176 6.04467L35.3555 6.57686L34.782 2.76881Z"
                                        fill="#FFCC00" />
                                    <path d="M32.7574 8.99987L35.544 6.97527L34.5317 5.58197L32.7574 8.99987Z"
                                        fill="#FFCC00" />
                                    <path d="M32.7574 8.99987L33.8218 5.72401L35.4597 6.2562L32.7574 8.99987Z"
                                        fill="#FFCC00" />
                                    <path d="M31.5061 5.14886L34.2927 7.17345L35.305 5.78015L31.5061 5.14886Z"
                                        fill="#FFCC00" />
                                    <path d="M31.5061 5.14886L34.9505 5.14886V6.87108L31.5061 5.14886Z"
                                        fill="#FFCC00" />
                                    <path d="M40.3219 16.5644L41.3863 13.2885L43.0242 13.8207L40.3219 16.5644Z"
                                        fill="#FFCC00" />
                                    <path d="M40.3219 16.5644L43.1085 14.5398L42.0962 13.1465L40.3219 16.5644Z"
                                        fill="#FFCC00" />
                                    <path d="M44.3711 16.5644L41.5845 14.5398L42.5968 13.1465L44.3711 16.5644Z"
                                        fill="#FFCC00" />
                                    <path d="M44.3711 16.5644L43.3067 13.2885L41.6688 13.8207L44.3711 16.5644Z"
                                        fill="#FFCC00" />
                                    <path d="M45.6223 12.7134L42.8357 14.738L41.8234 13.3447L45.6223 12.7134Z"
                                        fill="#FFCC00" />
                                    <path d="M45.6223 12.7134H42.1779V14.4356L45.6223 12.7134Z" fill="#FFCC00" />
                                    <path d="M39.0706 12.7134L41.8572 14.738L42.8695 13.3447L39.0706 12.7134Z"
                                        fill="#FFCC00" />
                                    <path d="M39.0706 12.7134H42.5151V14.4356L39.0706 12.7134Z" fill="#FFCC00" />
                                    <path d="M42.3465 10.3333L41.2821 13.6092L42.92 14.1414L42.3465 10.3333Z"
                                        fill="#FFCC00" />
                                    <path d="M42.3465 10.3333L43.4109 13.6092L41.7729 14.1414L42.3465 10.3333Z"
                                        fill="#FFCC00" />
                                    <path d="M39.0706 33.38H42.5151V35.1023L39.0706 33.38Z" fill="#FFCC00" />
                                    <path d="M39.0706 33.38L41.8572 35.4046L42.8695 34.0113L39.0706 33.38Z"
                                        fill="#FFCC00" />
                                    <path d="M40.3219 37.231L41.3863 33.9552L43.0242 34.4874L40.3219 37.231Z"
                                        fill="#FFCC00" />
                                    <path d="M40.3219 37.231L43.1085 35.2065L42.0962 33.8131L40.3219 37.231Z"
                                        fill="#FFCC00" />
                                    <path d="M44.3711 37.231L41.5845 35.2065L42.5968 33.8131L44.3711 37.231Z"
                                        fill="#FFCC00" />
                                    <path d="M44.3711 37.231L43.3067 33.9552L41.6688 34.4874L44.3711 37.231Z"
                                        fill="#FFCC00" />
                                    <path d="M42.3465 31L41.2821 34.2759L42.92 34.8081L42.3465 31Z" fill="#FFCC00" />
                                    <path d="M42.3465 31L43.4109 34.2759L41.7729 34.8081L42.3465 31Z" fill="#FFCC00" />
                                    <path d="M45.6223 33.38H42.1779V35.1023L45.6223 33.38Z" fill="#FFCC00" />
                                    <path d="M45.6223 33.38L42.8357 35.4046L41.8234 34.0113L45.6223 33.38Z"
                                        fill="#FFCC00" />
                                    <path d="M31.5061 40.9446H34.9506V42.6668L31.5061 40.9446Z" fill="#FFCC00" />
                                    <path d="M31.5061 40.9446L34.2927 42.9692L35.305 41.5759L31.5061 40.9446Z"
                                        fill="#FFCC00" />
                                    <path d="M32.7574 44.7956L33.8218 41.5197L35.4597 42.0519L32.7574 44.7956Z"
                                        fill="#FFCC00" />
                                    <path d="M32.7574 44.7956L35.544 42.771L34.5317 41.3777L32.7574 44.7956Z"
                                        fill="#FFCC00" />
                                    <path d="M36.8065 44.7956L34.0199 42.771L35.0322 41.3777L36.8065 44.7956Z"
                                        fill="#FFCC00" />
                                    <path d="M36.8065 44.7956L35.7422 41.5197L34.1042 42.0519L36.8065 44.7956Z"
                                        fill="#FFCC00" />
                                    <path d="M34.782 38.5645L33.7176 41.8404L35.3555 42.3726L34.782 38.5645Z"
                                        fill="#FFCC00" />
                                    <path d="M34.782 38.5645L35.8463 41.8404L34.2084 42.3726L34.782 38.5645Z"
                                        fill="#FFCC00" />
                                    <path d="M38.0578 40.9446H34.6134V42.6668L38.0578 40.9446Z" fill="#FFCC00" />
                                    <path d="M38.0578 40.9446L35.2712 42.9692L34.2589 41.5759L38.0578 40.9446Z"
                                        fill="#FFCC00" />
                                    <path
                                        d="M23.8619 81.3416H21.222L20.9803 79.6255C20.7162 80.0068 20.4044 80.3259 20.045 80.5826C19.6856 80.8392 19.3115 81.0483 18.9228 81.2096C18.5341 81.371 18.1418 81.4884 17.7459 81.5618C17.35 81.6352 16.9687 81.6719 16.6022 81.6719C15.4143 81.6719 14.3362 81.4592 13.3681 81.0337C12.4 80.6083 11.5749 80.0252 10.893 79.2844C10.2111 78.5437 9.68677 77.6784 9.31997 76.6885C8.95317 75.6987 8.76978 74.6317 8.76978 73.4877C8.76978 72.3436 8.95317 71.2766 9.31997 70.2865C9.68677 69.2964 10.2111 68.4311 10.893 67.6906C11.5749 66.9501 12.4 66.3671 13.3681 65.9416C14.3362 65.5162 15.4143 65.3035 16.6022 65.3035C17.4087 65.3035 18.219 65.4135 19.0329 65.6335C19.8469 65.8535 20.5838 66.1945 21.2438 66.6566C21.9038 67.1188 22.4574 67.7092 22.9048 68.4278C23.3522 69.1464 23.6199 69.9969 23.7081 70.9794H19.616C19.5426 70.3049 19.2163 69.7769 18.6371 69.3956C18.058 69.0142 17.3503 68.8236 16.5142 68.8235C15.854 68.8236 15.293 68.9556 14.831 69.2197C14.3691 69.4838 13.9915 69.8358 13.6981 70.2758C13.4047 70.7158 13.192 71.2144 13.0599 71.7716C12.9279 72.3289 12.8619 72.9009 12.8619 73.4877C12.8619 74.0745 12.9279 74.6465 13.0599 75.2037C13.192 75.761 13.4047 76.2596 13.6981 76.6996C13.9915 77.1396 14.3691 77.4916 14.831 77.7557C15.293 78.0198 15.854 78.1518 16.5142 78.1518C17.5262 78.1518 18.3512 77.9354 18.9893 77.5026C19.6273 77.0697 20.005 76.4941 20.1223 75.7758H17.2621V72.7398H23.8619V81.3416ZM30.5576 71.8152H33.7259C33.9018 71.8153 34.0888 71.7896 34.2868 71.7384C34.4849 71.6871 34.6645 71.6029 34.8256 71.4856C34.9867 71.3683 35.1224 71.2144 35.2325 71.0237C35.3426 70.833 35.3976 70.5983 35.3976 70.3194C35.3976 69.7474 35.2253 69.3514 34.8807 69.1314C34.536 68.9114 34.1511 68.8014 33.7259 68.8014H30.5576V71.8152ZM26.4655 65.6338H33.8138C34.4884 65.619 35.163 65.663 35.8377 65.7657C36.5125 65.8685 37.1211 66.0664 37.6636 66.3596C38.206 66.6527 38.646 67.056 38.9835 67.5694C39.321 68.0828 39.4897 68.7502 39.4897 69.5715C39.4897 70.2755 39.2991 70.9026 38.9177 71.4527C38.5364 72.0028 38.0377 72.4318 37.4219 72.7398C38.2575 72.9891 38.9174 73.4474 39.4014 74.1147C39.8855 74.7821 40.1275 75.5632 40.1276 76.4579C40.1275 77.3965 39.9662 78.1774 39.6435 78.8007C39.3208 79.424 38.8845 79.9226 38.3346 80.2965C37.7847 80.6705 37.1357 80.9382 36.3876 81.0995C35.6394 81.2609 34.8475 81.3416 34.0119 81.3416H26.4655V65.6338ZM30.5576 78.0638H33.8353C34.4807 78.0638 35.0088 77.9318 35.4195 77.6677C35.8301 77.4037 36.0354 76.9489 36.0355 76.3035C36.0354 75.6142 35.8228 75.1339 35.3976 74.8627C34.9724 74.5914 34.4516 74.4558 33.8353 74.4558H30.5576V78.0638Z"
                                        fill="#FBE712" />
                                </svg>

                                <form-field class="text-center" id="registrationIce" type="alpha-numeric" maxlength="7"
                                    v-model="quote.iceVehicle.registrationNumber"
                                    :error="$v.iceVehicle.registrationNumber.$error"
                                    @change="quote.iceVehicle.registrationNumber = quote.iceVehicle.registrationNumber.toUpperCase()" />
                            </div>

                            <uiv-btn type="primary" @click="onGetVehicle(quote.iceVehicle.registrationNumber)"
                                :disabled="requesting">
                                <loader :show="requesting" />Search
                            </uiv-btn>
                        </div>
                    </validation-messages>
                </div>

                <div class="col-xs-12 col-md-5">
                    <small>
                        Registration searches are available only for Car or Light Commercial Vehicle (LCV) classes that
                        are powered by an Internal Combustion Engine (ICE) only.
                    </small>
                </div>
            </div>

            <no-registration-vehicle ref="noReg" :electric-vehicle="false" @onClose="onCloseNoRegistration" />

            <div class="alert alert-danger" v-if="vehicleFound == 'notFound'">
                Vehicle could not be found
            </div>
            <div class="alert alert-danger" v-if="vehicleFound == 'notValid'">
                The registration you entered does not belong to a Car or Light Commercial Vehicle (LCV) and/or is not a
                vehicle with an Internal Combustion Engine (Petrol/Diesel).
            </div>
        </div>

        <div class="row _margin-top-20" v-show="quote.iceVehicle.make">
            <div class="col-md-7">
                <div class="detail-card">
                    <div class="detail-card-title">
                        Your Vehicle
                        <button type="button" class="btn btn-ghost btn-xs pull-right"
                            @click="onChangeVehicle">Change</button>
                    </div>

                    <vehicle-thumbnail :src="quote.iceVehicle.image" />
                    <p class="_margin-top-0 _margin-bottom-0">
                        <b>{{ quote.iceVehicle.make }} {{ quote.iceVehicle.model }}</b>
                        <!-- {{ ' ' }}
                        <span class="badge" v-if="quote.iceVehicle.isEv">
                            {{ quote.iceVehicle.batterySize }} kWh
                        </span>
                        <span class="badge" v-else>
                            {{ quote.iceVehicle.engineSize }} cc
                        </span> -->
                    </p>
                </div>
            </div>

            <div class="col-md-9 _margin-top-20" v-if="quote.iceVehicle.isEv">
                <div class="alert alert-danger">
                    The registration you entered does not belong to a Car or Light Commercial Vehicle (LCV) and/or is
                    not a vehicle with an Internal Combustion Engine (Petrol/Diesel).
                </div>
            </div>
        </div>

        <div class="card-footer">
            <div class="col-xs-6">
                <uiv-btn @click="onBack">Back</uiv-btn>
            </div>

            <div class="col-xs-6 text-right">
                <uiv-btn type="primary" @click="onGoToQuestion('next')"
                    :disabled="!quote.iceVehicle.make || quote.iceVehicle.isEv">Next</uiv-btn>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import NoRegistrationVehicle from './NoRegistrationVehicle';
import VehicleThumbnail from '../../vehicle-thumbnail/VehicleThumbnail';

export default {
    name: 'IceVehicle',
    data() {
        return {
            vehicleFound: null
        };
    },
    props: {
        $v: Object
    },
    computed: {
        ...mapState({
            quote: ({ quote }) => quote,
            vehicle: ({ lookups }) => lookups.vehicle,
            requesting: ({ lookups }) => lookups.requesting.vehicle,
            vehicleMakeList: ({ lookups }) => lookups.vehicleMakes,
            vehicleModelList: ({ lookups }) => lookups.vehicleModels,
            vehicleEngineList: ({ lookups }) => lookups.vehicleEngines
        })
    },
    methods: {
        ...mapActions({
            findVehicle: 'lookups/findVehicle',
            resetList: 'lookups/resetList',
            goToQuestion: 'quote_questions/goToQuestion'
        }),
        onNoReg() {
            if (!this.$refs.noReg) return;
            this.$refs.noReg.openModal();
        },
        onReset() {
            this.quote.iceVehicle.make = null;
            this.quote.iceVehicle.makeId = null;
            this.quote.iceVehicle.modelId = null;
            this.quote.iceVehicle.registrationNumber = null;
            this.vehicleFound = null;
            this.resetList('compareVehicles');
        },
        onChangeVehicle() {
            this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Change' });
            this.$store.dispatch('tracing/saveActions');
            this.onReset();
        },
        async onGetVehicle(registrationNumber) {
            this.$v.iceVehicle.registrationNumber.$touch();
            if (this.$v.iceVehicle.registrationNumber.$invalid) return;
            this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Existing Vehicle' });
            this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Vehicle Search' });
            this.$store.dispatch('tracing/addAction', { name: 'Value', value: registrationNumber });
            await this.$store.dispatch('tracing/saveActions');

            this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Existing Vehicle' });
            this.$v.$reset();
            const vehicle = await this.findVehicle({ registrationNumber, ev: false });


            if (vehicle == 404) {
                this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Vehicle Not Found' });
                this.$store.dispatch('tracing/saveActions');
                return this.vehicleFound = 'notFound';
            }

            if (vehicle == 409) {
                this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Vehicle Invalid' });
                this.$store.dispatch('tracing/saveActions');
                return this.vehicleFound = 'notValid';
            }

            this.quote.iceVehicle = { ...vehicle, dontKnow: false };
            this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Vehicle Search' });
            this.$store.dispatch('tracing/addAction', { name: 'Value', value: `${vehicle.make} ${vehicle.model}` });
            this.$store.dispatch('tracing/saveActions');
        },
        onDontKnow(e) {
            e.preventDefault();
            this.onReset();
            this.quote.iceVehicle.dontKnow = true;
            this.$refs.noReg.openModal();
        },
        onCloseNoRegistration(vehicle) {
            if (vehicle) {
                this.quote.iceVehicle = { ...this.quote.iceVehicle, ...vehicle };
            } else if (!this.quote.iceVehicle.makeId && !this.quote.iceVehicle.modelId) {
                this.onReset();
            }
        },
        onBack() {
            this.goToQuestion({ type: 'prev' });
            this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Existing Vehicle' });
            this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Back' });
            this.$store.dispatch('tracing/saveActions');
        },
        async onGoToQuestion(type) {
            this.$v.iceVehicle.$touch();

            if (this.$v.iceVehicle.$invalid) return;

            this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Existing Vehicle' });
            this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Next' });

            await this.goToQuestion({ type });
            await this.$store.dispatch('tracing/saveActions');
        }
    },
    components: {
        NoRegistrationVehicle,
        VehicleThumbnail
    }
};
</script>

<style lang="scss" scoped>
.vrn {
    display: flex;

    .vrn-input {
        margin-right: 10px;
    }
}

.vrn-input {
    overflow: hidden;
    position: relative;
    border: 1px solid #000;
    border-radius: 4px;
    background-color: #F3B701;
    padding-left: 23px;
    max-width: 200px;

    svg {
        height: 100%;
        position: absolute;
        top: 0;
        left: 4px;
        width: 16px;
        z-index: 10;
    }

    .form-control {
        box-shadow: -25px 0 0 #043F88;
        border: none;
        border-radius: 0 4px 4px 0;
        background-color: transparent;
        color: #000;
        letter-spacing: 2px;
        font-weight: bold;

        &:hover,
        &:focus {
            border: none;
        }
    }
}

.detail-card {
    padding: 0 15px 15px 15px;
    border-radius: 10px;
    border: 1px solid #dadada;

    .detail-card-title {
        min-height: 46px;
        font-size: 16px;
        padding: 13px 15px;
        margin: 0 -15px 10px -15px;
        border-bottom: 1px solid #dadada;
        font-weight: bold;

        .btn {
            position: relative;
            top: -3px;
        }
    }
}
</style>
